Array.prototype.searchFor = function(candid) {
    for (var i=0; i<this.length; i++)
        if (this[i].indexOf(candid) == 0)
            return i;
    return -1;
};
(function(){
	ele.cookieWarning = {

        cookieName: "cookieWarning", //cookie to record cookie consent

        prevFocus: null, //what had focus before we got into this

	    cookieSSOInterruptPage: function(){
            if(ele.config.cookieSSOInterrupt){
                if(ele.config.usersession.CMSEvent == 'beforeWeContinue'){
                    return true;
                }
            }
            return false;
        },

	    cookies: {
	        functionalityCookies: ['rap5_assemblerIntro', 'rap5_assemblerFeedback', 'evms'],
            performanceCookies: [
                '_ga', '_gat', '_gid' //google analytics
            ]
        },

        /* sets the cookie while checking against cookie permissions */
        setCookie: function(key,value,obj){
            if (ele.cookieWarning.readCookie().functionalityCookies ||
                ele.cookieWarning.cookies.functionalityCookies.indexOf(key) == -1) {
                $.cookie(key, value, obj);
            } else {
                //console.log("NOT SETTING COOKIE!");
            }
        },

        setLocalStorage: function(key, value) {
            if (ele.cookieWarning.readCookie().functionalityCookies ||
                ele.cookieWarning.cookies.functionalityCookies.indexOf(key) == -1) {
                if (typeof(Storage) !== "undefined") {
                    localStorage.setItem(key, value);
                }
            } else {
                //console.log("NOT SETTING localStorage!");
            }
        },

	    writeCookieWarningCookie: function(obj) {
            $.cookie(ele.cookieWarning.cookieName, JSON.stringify(obj), {
                expires: 60,	//expires in 60 days
                path: '/'	//apply to whole site
            });
        },

        readCookie: function(){
            if ($.cookie(ele.cookieWarning.cookieName)) {
                return JSON.parse($.cookie(ele.cookieWarning.cookieName));
            }
            return {
                shown: 0,
                performanceCookies: false,
                functionalityCookies: false
            };
        },

        removeCookie: function(v){
            window.localStorage.removeItem(v);
            $.removeCookie(v);
            $.removeCookie(v, { path: '/' });
            //cookies like _gaq are set on top level domain - so remove these too.
            if (window.location.hostname.split(".").length >= 3) {
                let mydomain = window.location.hostname.split(".");
                mydomain.shift();
                $.removeCookie(v, { path: '/', domain: mydomain.join(".")});
            }
        },

        /* opens panel and sets checkbox states */
        openPanel: function(){

            $("#cookieBox").removeClass("sHidden"); //initially the div is hidden. we don't show/hide further than this
            $("#cookieOverlay").fadeIn(200);
            $("#cookieBox").addClass("open");
            $(".closeCookieNotice").addClass("sHidden");

            this.checkboxStates();
            this.trapFocus();

        },

        checkboxStates: function(){
            $("#PerformanceCookieToggle").attr("checked", ele.cookieWarning.readCookie().performanceCookies).trigger("change");
            $("#FunctionalityCookieToggle").attr("checked", ele.cookieWarning.readCookie().functionalityCookies).trigger("change");
        },

        cookiePanelClose: function(e){
            $("#cookieOverlay").fadeOut(200);
            $("#cookieBox").removeClass("open");

            ele.cookieWarning.writeCookieWarningCookie({
                shown: 1,
                performanceCookies: $("#PerformanceCookieToggle").is(':checked'),
                functionalityCookies: $("#FunctionalityCookieToggle").is(':checked')
            });

            if ($("#PerformanceCookieToggle").is(':checked')) {

                window['ga-disable-' + ele.config.googleAnalytics] = false; //google analytics
                if (typeof fbq === 'function') fbq('consent', 'grant'); //facebook pixel

            } else {

                window['ga-disable-' + ele.config.googleAnalytics] = true; //google analytics
                if (typeof fbq === 'function') fbq('consent', 'revoke'); //facebook pixel

                //remove any previously set cookies/localstorage
                ele.cookieWarning.cookies.performanceCookies.forEach(function(v) {
                    ele.cookieWarning.removeCookie(v);
                });
            }

            if ($("#FunctionalityCookieToggle").is(':checked')) {
                //nothing really
            } else {
                //remove any previously set cookies/localstorage
                ele.cookieWarning.cookies.functionalityCookies.forEach(function(v) {
                    ele.cookieWarning.removeCookie(v);
                });
            }

            ele.cookieWarning.untrapFocus();
        },

        trapFocus: function() {
            this.prevFocus = $(":focus");
            this.resetFocus();
            $("#cookieBox").find('a[href]:not([disabled]):visible').first().focus();
        },

        resetFocus: function() {

            var cookieBox = $("#cookieBox"),
                focusableEls = cookieBox.find('a[href]:not([disabled]):visible, button:not([disabled]):visible, textarea:not([disabled]):visible, input[type="text"]:not([disabled]):visible, input[type="radio"]:not([disabled]):visible, input[type="checkbox"]:not([disabled]):visible, select:not([disabled]):visible'),
                firstFocusableEl = focusableEls[0],
                lastFocusableEl = focusableEls[focusableEls.length - 1],
                KEYCODE_TAB = 9;

            cookieBox.off('keydown');
            cookieBox.on('keydown', function(e) {
                var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

                if (!isTabPressed) {
                    return;
                }

                if ( e.shiftKey ) /* shift + tab */ {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else /* tab */ {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }

            });

        },

        untrapFocus: function() {
            $("#cookieBox").off('keydown');
            this.prevFocus.focus();
        },

		init: function() {
            var me = this;

            if ($("#cookieBox").length > 0) {

                /* on toggle, change label to "Off" or "On" */
                $('#cookieBox .custom-control-input').on('change', function () {
                    if ($(this).is(':checked')) {
                        $(this).siblings(".custom-control-label").find(".cookie-status").text(i18n('js_cookie_on'))
                    } else {
                        $(this).siblings(".custom-control-label").find(".cookie-status").text(i18n('js_cookie_off'))
                    }
                });

                /* click to open panel */
                $("#cookiePreferenceLink").on("click", function (e) {
                    ele.cookieWarning.openPanel();
                    if (!$("#cookieManageToggle").hasClass("active")) {
                        $("#cookieManageToggle").click();
                    }
                    return false;
                })

                /*click to close panel */
                $("#cookieClose").on("click", function (e) {
                    if(ele.cookieWarning.cookieSSOInterruptPage()) {
                        // defer to the handler in the beforeWeContinue app
                    } else {
                        ele.cookieWarning.cookiePanelClose();
                    }
                });

                /* click to toggle the cookie manage section */
                $("#cookieManageToggle").on("click", function(e) {
                    $(this).toggleClass("active");
                    $(this).find("i").toggleClass("fa-chevron-up");
                    $(this).find("i").toggleClass("fa-chevron-down");

                    $("#cookieManage").slideToggle(100, function() {
                        me.resetFocus(); //reset focus list
                    });

                    return false;
                })

                if(ele.cookieWarning.cookieSSOInterruptPage()) {
                    ele.cookieWarning.checkboxStates()
                } else {
                    if (ele.cookieWarning.readCookie().shown == 0) {
                        ele.cookieWarning.openPanel();
                    }
                }
            } else { //old banner
                if (!$.cookie("cookieWarningShown")) {
                    var $elem = $($('#e_cookieWarningTemplate').html());
                    $elem.find('#e_cookieWarningClose').click(function () {
                        $("#e_cookieWarning").slideUp("fast");
                    });
                    $("body").prepend($elem);
                    $elem.slideDown("fast");

                    //only show on button click
                    $("#e_cookieWarningClose").on("click", function() {
                        $.cookie("cookieWarningShown", 1, {
                            expires: 60,	//expires in 60 days
                            path: '/'	//apply to whole site
                        });
                    });
                }
                if (!$.cookie(ele.cookieWarning.cookieName)) {
                    //to stop new behaviour screwing stuff up
                    ele.cookieWarning.writeCookieWarningCookie({
                        shown: 1,
                        performanceCookies: true,
                        functionalityCookies: true
                    });
                }

            }
		}
	};
	
	$(function(){
        if(ele.cookieWarning.cookieSSOInterruptPage()) {
            // we don't init here, the app, handles that
        } else {
            ele.cookieWarning.init();
        }
	});
})();
